import { useMemo, useState } from 'react';
import { useLang } from 'hooks/lang';

import { isLeader } from 'entities';

import { UsersIcon } from 'components/Icons';

import { TeamUser } from './TeamUser';
import { ItemGroup } from '../../ItemGroup';

import { useUser } from 'hooks';
import { useTeam } from 'providers/Team';

export function MyTeam() {
  const loggedUser = useUser();
  const { teamUsers } = useTeam();

  const [overdueControl, setOverdueControl] = useState<Record<string, boolean>>({});

  const { t } = useLang();

  const sortedUsers = useMemo(() => {
    return teamUsers.filter(({ id }) => id !== loggedUser.id);
  }, [teamUsers, loggedUser]);

  const shouldShow = [
    isLeader(loggedUser),
    loggedUser.team.canAssumeProject || loggedUser.team.hasServices,
  ].every(Boolean);

  if (!shouldShow) return null;

  return (
    <ItemGroup
      name={t('my-team')}
      icon={<UsersIcon size={22} />}
      items={sortedUsers}
      itemKey="id"
      addErrorIndication={Object.values(overdueControl).some(Boolean)}
      itemClassName="p-2"
      render={(entry) => (
        <TeamUser
          user={entry}
          key={`${entry.id}-side-bar-view`}
          onOverdueChange={(hasOverdue) =>
            setOverdueControl((old) => ({ ...old, [entry.id]: hasOverdue }))
          }
        />
      )}
    />
  );
}
